module.exports = "https://trybtryb-legacy.web.app/img/upload.2019fab4.svg";